import { useState, useEffect } from "react";
import { cn } from "tailwind-variants";
import ArtworkError from "./ArtworkError.vue";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";
import "./DtfAddToCart.scss";

export default function DtfAddToCart({ ...restProps }) {
  const store = useDtfStore();
  const spanglesStore = useSpanglesStore();
  const [submittedOnMousedown, setSubmittedOnMousedown] = useState(false);

  function artworks() {
    return store.artworks;
  }

  function modalArtworks() {
    return store.modalArtworks;
  }

  function isReadyForOrder() {
    return store.isReadyForOrder;
  }

  function currentStore() {
    return store.currentStore;
  }

  function catalogNumber() {
    return store.catalogNumber;
  }

  function isSpangle() {
    return store.isSpangle;
  }

  function removeBgLoading() {
    return store.removeBgLoading;
  }

  function spangleSizeEditing() {
    return spanglesStore.spangleSizeEditing;
  }

  function spanglesLoading() {
    return spanglesStore.spanglesLoading;
  }

  function spangleSizeEdited() {
    return spanglesStore.spangleSizeEdited;
  }

  function invalidSpangleSelected() {
    return spanglesStore.invalidSpangleSelected;
  }

  function allAPIsCompleted() {
    return spanglesStore.allAPIsCompleted;
  }

  function backgroundProcessesLoading() {
    return removeBgLoading();
  }

  function disableOrderButton() {
    if (backgroundProcessesLoading()) {
      return true;
    }
    if (isSpangle()) {
      return (
        !isReadyForOrder() ||
        spangleSizeEditing() ||
        spanglesLoading() ||
        !allAPIsCompleted() ||
        !spangleSizeEdited() ||
        invalidSpangleSelected()
      );
    }
    return !isReadyForOrder();
  }

  function spangleErrorObject() {
    return {
      errorMessage: "Please finish editing the size of the artwork before adding it to cart."
    };
  }

  function submitForm(...args) {
    return store.submitForm(...args);
  }

  function onMousedown() {
    setSubmittedOnMousedown(false);
    submitForm();
    setSubmittedOnMousedown(true);
  }

  function onClick() {
    if (submittedOnMousedown) {
      setSubmittedOnMousedown(false);
      return;
    }
    submitForm();
  }

  useEffect(() => {
    if (disableOrderButton()) {
      setSubmittedOnMousedown(false);
    }
  }, [disableOrderButton()]);

  return (
    <div {...restProps} className={cn("dtf-add-to-cart scope-c944b75f", restProps?.className)}>
      <div className="dtf-add-to-cart__submit-wrap scope-c944b75f">
        <button
          className="dtf-add-to-cart__button scope-c944b75f"
          type="button"
          disabled={disableOrderButton()}
          data-testid="dtf-add-to-cart-button"
          onMouseDown={e => {
            if (e.button !== 0) return;
            onMousedown();
          }}
          onClick={onClick}
        >
          {" "}
          Add To Cart{" "}
        </button>
      </div>
      {spangleSizeEditing() ? (
        <ArtworkError
          className="scope-c944b75f"
          artwork={spangleErrorObject()}
          data-testid="artwork-error"
        />
      ) : null}
    </div>
  );
}
